import Productos from "ab-products";
import { useTranslation } from "next-i18next";

const NuestraSugerencias = ({ classname, moduloCross, i18n }) => {
  let disfrute = moduloCross?.modCrossSugerencias;
  const { t } = useTranslation("common", { i18n });

  // console.log("NuestraSugerencias - ", disfrute);
  return (
    <Productos
      title={
        i18n.language == "en"
          ? disfrute?.titlesugerenciasen || disfrute?.titlesugerencias
          : i18n.language == "de"
          ? disfrute?.titlesugerenciasde || disfrute?.titlesugerencias
          : disfrute?.titlesugerencias
      }
      className={`${classname} ${disfrute?.classnamesugerencias}`}
      products={disfrute?.products?.map((itm) => ({
        name: itm.product?.name,
        price: itm.product?.price,
        src: itm.product?.image?.mediaItemUrl,
        href: `${t("/tienda")}/${itm.product?.slug}`,
        id: itm.product.databaseId,
        location: "Nuestras Sugerencias",
      }))}
      i18n={i18n}
    />
  );
};

export default NuestraSugerencias;
